import { render, staticRenderFns } from "./NPSMainPage.vue?vue&type=template&id=0ac689c6&scoped=true"
import script from "./NPSMainPage.vue?vue&type=script&lang=js"
export * from "./NPSMainPage.vue?vue&type=script&lang=js"
import style0 from "./NPSMainPage.vue?vue&type=style&index=0&id=0ac689c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac689c6",
  null
  
)

export default component.exports